import { useEffect } from "react";
import { AppRouter } from "@/zapi-frontend/app/providers/router";
import { useSentry } from "../shared/hooks/useSentry";
import { useIdentifySessionByEmail } from "@/zapi-frontend/app/providers/analytics";
import { initializeOrganizationHandling } from "@/zapi-frontend/shared/api/organizationInterceptor";
import { initializeLocalStorage } from "../shared/local-storage/initializeLocalStorage";
import { useNotificationSSE } from "@/zapi-frontend/features/Notifications";
import { CookieConsentModal } from "@/zapi-frontend/widgets/CookieConsentModal";

export function App() {
  useSentry();
  useIdentifySessionByEmail();
  useNotificationSSE();

  useEffect(() => {
    initializeOrganizationHandling();
    initializeLocalStorage();
  }, []);

  return (
    <div className="min-h-screen">
      <AppRouter />
      <CookieConsentModal />
    </div>
  );
}

export default App;
